export default __webpack_public_path__ + "static/media/bg-Welcome.b491e1a8.jpg";